<script>
  import Header from  './blocks/Header.svelte';
  import Header2 from  './blocks/Header2.svelte';
  import Footer from  './blocks/Footer.svelte';
  import Header7 from  './blocks/Header7.svelte';
  import Features8 from  './blocks/Features8.svelte';
  import Project4 from  './blocks/Project4.svelte';
  import Content1 from  './blocks/Content1.svelte';
  import Features13 from  './blocks/Features13.svelte';
  import Prefooter1 from  './blocks/Prefooter1.svelte';
  import Header10 from './blocks/Header10.svelte';
  import Table1 from './blocks/Table1.svelte';
  import Features2 from './blocks/Features2.svelte';
  import Content1Header from './blocks/Content1Header.svelte';
  import Team4 from './blocks/Team4.svelte';
  import Blog10 from './blocks/Blog10.svelte';
  import Paragraph from './blocks/Paragraph.svelte';
  import HeaderWave from './blocks/HeaderWave.svelte';
  import Blog5 from './blocks/Blog5.svelte';
  import Blog10Cards from './blocks/Blog10Cards.svelte';
  import Pricing5 from './blocks/Pricing5.svelte';
  import Pricing4 from './blocks/Pricing4.svelte';
  import Team3 from './blocks/Team3.svelte';
  import Project3 from './blocks/Project3.svelte';
  import Contact from './blocks/Contact.svelte';
  import FooterV3 from './blocks/FooterV3.svelte';

  export let blocks = [];
  export let wip;

  function hide(ev) {
      ev.target.style.display = 'none';
  }
</script>

<div>
  {#each blocks as block}
  <div id="{block.name_slug}" style="position: relative;">
    {#if wip}<div class="wip-tag" on:click={hide}>{block.name}</div>{/if}
    {#if block.slug == "contact"}<Contact block={block} />{/if}
    {#if block.slug == "header"}<Header block={block} />{/if}
    {#if block.slug == "header-7"}<Header7 block={block} />{/if}
    {#if block.slug == "header-2"}<Header2 block={block} />{/if}
    {#if block.slug == "features-8"}<Features8 block={block} />{/if}
    {#if block.slug == "project-4"}<Project4 block={block} />{/if}
    {#if block.slug == "content-1"}<Content1 block={block} />{/if}
    {#if block.slug == "features-13"}<Features13 block={block} />{/if}
    {#if block.slug == "prefooter-1"}<Prefooter1 block={block} />{/if}
    {#if block.slug == "header-10"}<Header10 block={block} />{/if}
    {#if block.slug == "table-1"}<Table1 block={block} />{/if}
    {#if block.slug == "features-2"}<Features2 block={block} />{/if}
    {#if block.slug == "content-1-header"}<Content1Header block={block} />{/if}
    {#if block.slug == "team-4"}<Team4 block={block} />{/if}
    {#if block.slug == "blog-10"}<Blog10 block={block} />{/if}
    {#if block.slug == "paragraph"}<Paragraph block={block} />{/if}
    {#if block.slug == "header-wave"}<HeaderWave block={block} />{/if}
    {#if block.slug == "blog-5"}<Blog5 block={block} />{/if}
    {#if block.slug == "blog-10-cards"}<Blog10Cards block={block} />{/if}
    {#if block.slug == "pricing-5"}<Pricing5 block={block} />{/if}
    {#if block.slug == "pricing-4"}<Pricing4 block={block} />{/if}
    {#if block.slug == "team-3"}<Team3 block={block} />{/if}
    {#if block.slug == "project-3"}<Project3 block={block} />{/if}
    {#if block.slug == "footer"}<Footer block={block} />{/if}
    {#if block.slug == "footerv3"}<FooterV3 block={block} />{/if}
  </div>
  {/each}
  <!-- Add js main source below -->
</div>

<style>
  .wip-tag {
      position: absolute;
      background-color: blue;
      color: white; 
      padding: 5px;
      right: 0px;
      z-index: 10000;
      top: 50%;
      transform: translateY(-50%);
      font: 1em sans-serif;
  }
</style>
